module.exports = __webpack_public_path__ + "static/ma-3-sq-ad9061dc8934efe0731f8c48d27ff780.png";